/**
 * URL del backend: mismo origen que la página (HTTPS en producción).
 * Evita Mixed Content si el build antiguo tenía http://IP.
 */
const resolveBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/$/, '');
  }
  return 'https://www.homesconstructora.com';
};

const BACKEND_URL = resolveBackendUrl();

export const config = {
  backendUrl: BACKEND_URL,
  uploadsUrl: `${BACKEND_URL}/uploads`,
  apiUrl: `${BACKEND_URL}/api`,
  subdivisionWebUrl: `${BACKEND_URL}/subdivision-web/crear_expediente.html`
};

export default config;
